export const parameterize = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 -]/g, ' ') // convert unwanted chars to spaces
    .replace(/\s\s+/g, ' ') // convert multi spaces to single space
    .replace(/\s/g, '-') // convert spaces to hyphens
    .replace(/--+/g, '-')
}

export const filenameFragments = (filename) => {
  const extension = filename.split('.').pop()
  const basename = parameterize(filename).replace(`-${extension}`, '')
  return {basename, extension}
}

export const parameterizeFilename = (filename) => {
  const {basename, extension} = filenameFragments(filename)
  return [basename, extension].join('.')
}
